export const MERGE_VIEW_PARAMS = "@router/MERGE_VIEW_PARAMS";
export const STORE_LOCATION = "@router/STORE_LOCATION";
